import type { DataStatus, MetricValue } from '@oxxean/types';
import { http } from '../http';
import type { DashboardFilters } from '@oxxean/types';
import { filtersToParams } from './params';

export interface DiversityCategory {
  key: string;
  label: string;
  count: number;
  share: MetricValue;
}

export interface DiversityDimension {
  categories: DiversityCategory[];
  /** Personas con el atributo informado. */
  withData: number;
  /** Personas sin él. NO se reparten entre las categorías ni se descartan. */
  withoutData: number;
  coverage: MetricValue;
  status: DataStatus;
}

export interface DiversityByCompany {
  company: string;
  total: number;
  byGender: DiversityCategory[];
}

export interface DiversityReport {
  total: number;
  generatedAt: string;
  gender: DiversityDimension;
  ageRange: DiversityDimension;
  nationality: DiversityDimension;
  byCompany: DiversityByCompany[];
  /** Dimensiones que BUK no entrega, con el motivo. Nunca llegan como 0 %. */
  disability: { label: string; metric: MetricValue; legalNote: string };
  education: { label: string; metric: MetricValue };
}

export async function fetchDiversity(filters: DashboardFilters): Promise<DiversityReport> {
  const response = await http.get<DiversityReport>('/metrics/diversity', {
    params: filtersToParams(filters),
  });
  return response.data;
}
